/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework from '@greenville/framework';
import utils from '../../../../common/utils';

export default function handleEvalReportError(error) {
  const { response } = error;
  if (response) {
    const { status, data } = response;
    if (status === 401) {
      utils.redirectToLogin();
    }
    if (status === 500 && data?.error) {
      Framework.getStoreRegistry().getStore('notificationState').set({
        open: true,
        message: data.error.message,
        type: 'error'
      });
    }
  } else if (error.message === 'timeout of 60000ms exceeded') {
    Framework.getStoreRegistry().getStore('notificationState').set({
      open: true,
      message: error.message,
      type: 'error'
    });
  }
}
